/**
 * Markup helper — bakes the tradie's markup % invisibly into every line item
 * so the client-facing invoice only shows labour + materials at the final
 * marked-up price. The markup itself is NEVER exposed as a separate line.
 *
 * This is how real invoicing software (Xero, MYOB) handles it: markup is an
 * internal pricing input, not a customer-facing line.
 *
 * @param {Array<{description:string, quantity:number, unit_price:number, kind?:string}>} items
 * @param {number|string} markupPercent  e.g. 15 for 15%
 * @returns {Array} same shape, with markup baked into each unit_price.
 */
export function bakeMarkupIntoItems(items, markupPercent) {
  const m = Number(markupPercent) || 0;
  if (m <= 0) return items;
  const factor = 1 + m / 100;
  return items.map((i) => ({
    ...i,
    unit_price: Math.round((Number(i.unit_price || 0) * factor) * 100) / 100,
  }));
}
